import { Type } from 'class-transformer';
import { IsBoolean, IsOptional, IsString, ValidateNested } from 'class-validator';

export class OpeningHoursDayDto {
  @IsBoolean()
  @IsOptional()
  isOpen?: boolean;

  @IsBoolean()
  @IsOptional()
  byAppointmentOnly?: boolean;

  @IsString()
  @IsOptional()
  morningOpen?: string;

  @IsString()
  @IsOptional()
  morningClose?: string;

  @IsString()
  @IsOptional()
  afternoonOpen?: string;

  @IsString()
  @IsOptional()
  afternoonClose?: string;
}

export class OpeningHoursDto {
  @IsOptional()
  @ValidateNested()
  @Type(() => OpeningHoursDayDto)
  monday?: OpeningHoursDayDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => OpeningHoursDayDto)
  tuesday?: OpeningHoursDayDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => OpeningHoursDayDto)
  wednesday?: OpeningHoursDayDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => OpeningHoursDayDto)
  thursday?: OpeningHoursDayDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => OpeningHoursDayDto)
  friday?: OpeningHoursDayDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => OpeningHoursDayDto)
  saturday?: OpeningHoursDayDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => OpeningHoursDayDto)
  sunday?: OpeningHoursDayDto;

  @IsString()
  @IsOptional()
  notes?: string;
}
